import ECOne from '../images/ECOne.jpg';
import RGOne from '../images/RGOne.jpg';
import ICOne from '../images/ICOne.jpg';

export const SliderData = [
  {
    title: 'Residences at the Galleon',
    price: 'Php 20,000',
    path: '/homes',
    label: 'View Home',
    image: RGOne,
    alt: 'Residences at the Galleon',
  },
  {
    title: 'Empress at Capital Commons',
    price: 'Php 20,000,000',
    path: '/homes',
    label: 'View Home',
    image: ECOne,
    alt: 'Emperial at Capitol Commons',
  },
  {
    title: 'Ibiza at Circulo Verde',
    price: 'Php 20,000,000',
    path: '/homes',
    label: 'View Home',
    image: ICOne,
    alt: 'Ibiza at Circulo Verde',
  },
];
